<template>
  <!-- <div class="name-place u-white u-relative u-flex u-cursor-pointer u-pointer-all" @click="$emit('click')" :class="{'is-active': isActive}">
    <img class="name-place__bg u-full-width u-wrapper-panel" src="/images/pointer.png">
    <div class="u-relative u-middle u-center u-uppercase t-text--small">
      {{name}}
    </div>
  </div> -->
  <app-button :hasGradient="true" class="name-place u-pointer-all" @click="$emit('click')" :class="{'is-active': isActive}">
    {{name}}
  </app-button>
</template>

<script>
import Object3d from '@/plugins/Dom3d/mixin'

export default {
  mixins: [Object3d],

  props: {
    name: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: false
    }
  }
}

</script>

<style lang="stylus">
.name-place
  opacity 0
  transition opacity .3s linear
  padding 5px 20px !important
  // padding 5px 15px 10px
  
  &.is-active
    opacity 1
</style>